// @ngInject
function UsersApiService($q, $window,DS,DSHttpAdapter,ResourcesService) {

    var endpoint = 'users';

    return {
        getSelf: getSelf,
        getAll:  ResourcesService.apiFactory.get(endpoint),
        listAll: ResourcesService.apiFactory.get(endpoint + '/brief'),
        getById: getById,
        newUser: newUser,
        updateUserInfo: updateUserInfo,
        getAddressTypes: ResourcesService.apiFactory.get(endpoint + '/addresstypes'),
        getContactInfoTypes: ResourcesService.apiFactory.get(endpoint + '/contactinfotypes'),
        getValidRoles: ResourcesService.apiFactory.get(endpoint + '/validuserroles'),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getBrands: ResourcesService.apiFactory.get(endpoint + '/brands'),
        printQRCode: printQRCode
    };

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36012-36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s-_]){1,}.(pdf|csv|xls|xlsx)/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function printQRCode(userId, password) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/qrcode' + '?userId='+ userId + '&password=' + password, {responseType: 'arraybuffer'}).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'USER_QRCODE.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;

    }

    function getSelf() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'users/me').then(function(response) {
            var user = DS.inject('user', response.data);
            deferred.resolve(user);
        }, function(error) {
            deferred.reject(handleError(error));
        });
        return deferred.promise;
    }

    function getById(id) {
        var deferred = $q.defer();

        DS.find('user', id, { bypassCache: true }).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function newUser(user) {
        var deferred = $q.defer();


        if (user.brands) {
            user.brands = _.map(user.brands, _.partialRight(_.pick, "id"));
        }

        if (user.locations) {
            user.locations = _.map(user.locations, _.partialRight(_.pick, "id"));
        }

        if (user.roles) {
            user.roles = _.map(user.roles, _.partialRight(_.pick, "id"));
        }

        DS.create('user', user).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateUserInfo(data, id) {
        var deferred = $q.defer();

        if (data.brands) {
            data.brands = _.map(data.brands, _.partialRight(_.pick, "id"));
        }

        if (data.locations) {
            data.locations = _.map(data.locations, _.partialRight(_.pick, "id"));
        }

        if (data.roles) {
            data.roles = _.map(data.roles, _.partialRight(_.pick, "id"));
        }

        DS.update('user', id, data, { cacheResponse: false }).then(function(response) {
            var user = DS.get('user', id);
            user.firstName = response.firstName;
            user.lastName = response.lastName;
            user.username = response.username;
            user.isActive = response.isActive;
            user.addresses = response.addresses;
            user.employeeNumber = response.employeeNumber;
            user.usernamePos = response.usernamePos;
            user.startDate = response.startDate;
            user.locations = response.locations;
            user.brands = response.brands;
            user.contactInfos = response.contactInfos;
            DS.inject('user',user);
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('users.api',[])
    .factory('UsersApiService', UsersApiService);
